//import { Fancybox } from '@fancyapps/ui';
import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';
import Modal from './modules/modal.js'; //quite
import mobileMenu from './modules/mobile-menu.js'; //quite

//Touch sniffer
if ('ontouchstart' in document.documentElement) {
	document.querySelector('html').classList.add('is-touch');
}

// Init functions on pageload
function init() {
	Fancybox.bind('[data-fancybox]');

	mobileMenu();
	new Modal();
}

jQuery(document).ready(($) => {
	init();

	var svgLetters = '#collegave .i, #collegave .c, #collegave .t';
	$(svgLetters).hover(
		function (e) {
			$(svgLetters + ', #Laag_1-2').css('opacity', '.2');
			$('.' + this.classList.value).css('opacity', '1');
		},
		() => {
			$(svgLetters + ', #Laag_1-2').css('opacity', '1');
		}
	);

	if ($(window).width() < 768) {
		$('.tabs-nav li a').click(function () {
			var scrollid = $(this).data('tab');
			$('html, body').animate(
				{
					scrollTop: $('#tab-1').offset().top
				},
				2000
			);
		});
	}
});

//------------------------------------//
// DELETE ACTIVE STATE
//------------------------------------//
const removeActive = (selector) => {
	[...document.querySelectorAll(selector)].forEach(
		(el) => delete el.dataset.active
	);
};

//------------------------------------//
// TABS
//------------------------------------//
const tabTriggers = document.querySelectorAll('.tabs-nav a');

[...tabTriggers].forEach((trigger) => {
	trigger.addEventListener('click', switchTab);
});

function switchTab(e) {
	e.preventDefault();
	const targetTab = e.currentTarget.dataset.tab;

	removeActive('.tab[data-active]');
	removeActive('.tabs-nav a[data-active]');

	e.currentTarget.dataset.active = true;
	document.querySelector(`.tab[data-tab='${targetTab}']`).dataset.active = true;
}

//------------------------------------//
// SWIPER - NEWS
//------------------------------------//
const swiperNews = new Swiper('.swiper-news', {
	// Optional parameters
	loop: true,
	slidesPerView: 1.25,
	spaceBetween: 20,

	// If we need pagination
	pagination: {
		el: '.grid .swiper-pagination',
		type: 'fraction'
	},

	// Navigation arrows
	navigation: {
		nextEl: '.grid .button-next',
		prevEl: '.grid .button-prev'
	},
	breakpoints: {
		// when window width is >= 320px
		600: {
			slidesPerView: 1.5
		},
		// when window width is >= 480px
		768: {
			slidesPerView: 1.75
		},
		// when window width is >= 640px
		992: {
			slidesPerView: 2,
			spaceBetween: 30
		},
		1024: {
			slidesPerView: 2.5,
			spaceBetween: 50
		}
	}
});

//------------------------------------//
// SWIPER - HERO
//------------------------------------//

const titleSwiper = new Swiper('.title-slider', {
	// Optional parameters
	loop: true,
	slidesPerView: 1,
	spaceBetween: 0,
	direction: 'vertical',
	modules: [Autoplay],

	autoplay: {
		delay: 1500
	}
});
//------------------------------------//
// SWIPER - LOGO
//------------------------------------//
const partnerSwiper = new Swiper('.partners-slider', {
	// Optional parameters
	loop: true,
	slidesPerView: 2.5,
	spaceBetween: 40,
	modules: [Autoplay],

	autoplay: {
		delay: 6000
	},
	breakpoints: {
		768: {
			slidesPerView: 3.5,
			spaceBetween: 60
		},
		1024: {
			slidesPerView: 5,
			spaceBetween: 100
		},
		1200: {
			slidesPerView: 6.5,
			spaceBetween: 100
		}
	}
});

const customerSwiper = new Swiper('.customers-slider', {
	// Optional parameters
	loop: true,
	slidesPerView: 2.5,
	spaceBetween: 40,
	modules: [Autoplay],

	autoplay: {
		delay: 1500
	},
	breakpoints: {
		768: {
			slidesPerView: 3.5,
			spaceBetween: 60
		},
		1024: {
			slidesPerView: 5,
			spaceBetween: 100
		},
		1200: {
			slidesPerView: 6.5,
			spaceBetween: 100
		}
	}
});

//------------------------------------//
// SWIPER - LOGO
//------------------------------------//
const historySwiper = new Swiper('.history-slider', {
	// Optional parameters
	modules: [Navigation],
	slidesPerView: 1.5,
	spaceBetween: 40,
	navigation: {
		nextEl: '.history .swiper-next',
		prevEl: '.history .swiper-prev'
	},
	breakpoints: {
		768: {
			slidesPerView: 2.5
		},
		1024: {
			slidesPerView: 3.5
		},
		1200: {
			slidesPerView: 4.5
		}
	}
});

//------------------------------------//
// SWIPER - GALLERY
//------------------------------------//
const gallerySwiper = new Swiper('.gallery-slider', {
	// Optional parameters
	slidesPerView: 1.75,
	spaceBetween: 40,
	centeredSlides: true,
	loop: true,
	modules: [Autoplay, Navigation],
	autoplay: {
		delay: 1500
	},
	navigation: {
		nextEl: '.gallery .swiper-next',
		prevEl: '.gallery .swiper-prev'
	},
	breakpoints: {
		0: {
			slidesPerView: 1.2
		},
		768: {
			slidesPerView: 2.75
		},
		1024: {
			slidesPerView: 3.75
		}
	}
});

//------------------------------------//
// SWIPER - GALLERY
//------------------------------------//
const blogSwiper = new Swiper('.swiper-blog', {
	// Optional parameters
	slidesPerView: 1.1,
	spaceBetween: 40,
	loop: true,
	modules: [Navigation],
	navigation: {
		nextEl: '.news .swiper-next',
		prevEl: '.news .swiper-prev'
	},
	breakpoints: {
		768: {
			slidesPerView: 2
		},
		992: {
			slidesPerView: 3
		}
	}
});
